/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Mobile-Nav
jQuery(document).ready(function($) {
            jQuery('.stellarnav').stellarNav({
                theme: 'dark',
                breakpoint: 992,
                position: 'left',
                phoneBtn: false,
                closeLabel: '',
                locationBtn: false
            });
        });

//Banner
$(document).ready(function(){
$('.splash-slider, .i-1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 2000,
        arrows: true,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        infinite: true,
        cssEase: 'ease-in-out',
        touchThreshold: 100,
        pauseOnHover: false,
        pauseOnFocus: false
})

//Items-3
$('.i-3').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '10px',
        variableWidth: false,
        autoplay: true,    
        autoplaySpeed: 2000,
        fade: false,
        arrows: true,
        dots: false,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
 ]
})
  //Items-5
$('.i-5').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: false,
        autoplay: false,        
        fade: false,
        arrows: false,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 650,
      settings: {
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
 ]
})

//Items-6
$('.i-6').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: false,
        autoplay: false,        
        fade: false,
        arrows: true,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 650,
      settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
 ]
})
//Ingredients
$('.ingr').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: false,
        autoplay: false,        
        fade: false,
        arrows: true,
        nextArrow: '<a class="next slick-next"><i class="fa fa-chevron-right"></i></a>',
        prevArrow: '<a class="prev slick-prev"><i class="fa fa-chevron-left"></i></a>',
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
 ]
})
});

//Tabs
 $(document).ready(function(){
  $('.tab-content:first-child').show();
  $('.tab-nav-link').bind('click', function(e) {
    $this = $(this);
    $tabs = $this.parent().parent().next();
    $target = $($this.data("target")); // get the target from data attribute
    $this.siblings().removeClass('current');
    $target.siblings().css("display", "none")
      $this.addClass('current');
      $target.fadeIn("fast");
  });
  $('.tab-nav-link:first-child').trigger('click');
}); 
 
//Jarallax
$(document).ready(function(){
  /*jarallax(document.querySelectorAll(".jarallax"));
  jarallax(document.querySelectorAll(".jarallax-keep-img"), {
  keepImg: true,*/
});

//Collapsible
var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

//AOS
$(document).ready(function() {
    var aos = new AOS.init(); 
    
});

//Scroll-To-Section
$('a.page-scroll').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 900);
            return false;
        }
    }
});

//Accordion
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

//Menu Highlight
var lastId,
    topMenu = $("#locator"),
    topMenuHeight = topMenu.outerHeight()+0,
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

// Bind to scroll
$(window).scroll(function(){
   // Get container scroll position
   var fromTop = $(this).scrollTop()+topMenuHeight;
   
   // Get id of current scroll item
   var cur = scrollItems.map(function(){
     if ($(this).offset().top < fromTop)
       return this;
   });
   // Get the id of the current element
   cur = cur[cur.length-1];
   var id = cur && cur.length ? cur[0].id : "";
   
   if (lastId !== id) {
       lastId = id;
       // Set/remove active class
       menuItems
         .parent().removeClass("active")
         .end().filter("[href='#"+id+"']").parent().addClass("active");
   }                   
});

//Scroll-To-Section
$('a.page-scroll').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 900);
            return false;
        }
    }
});
